import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import useStyles from "../../styles";
import { httprequest } from "../../../../data/api";
import { toast } from "react-toastify";
import MaterialPreviewModal from "../../components/MaterialPreviewModal";
import { formatFileSize, getFileMeta } from "../../employer/utils/uploadFile";

const SYLLABUS_ENDPOINT = "/api/v1/syllabus";

const StudentSyllabusTopicDetails = () => {
  const { subjectId, topicId } = useParams();
  const classes = useStyles();

  const syllabusLink = `/class-activities/syllabus/${subjectId}`;

  const [topic, setTopic] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [previewMaterial, setPreviewMaterial] = useState(null);

  const getTopic = () => {
    setIsLoading(true);
    httprequest.get(`${SYLLABUS_ENDPOINT}/topics/${topicId}`)
      .then((res) => {
        setTopic(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message || "Failed to load topic");
      });
  };

  useEffect(() => {
    getTopic();
  }, [topicId]);

  const progress = topic?.progress;
  const isCompleted = progress === "COMPLETED";

  const materials = topic?.materials || [];

  return (
    <Layout
      children={
        <>
          <BreadCrumb
            link_one={syllabusLink}
            link_one_name="Syllabus"
            active={topic?.title || ""}
          />

          {!isLoading && topic && (
            <div className="page-content" style={{ marginTop: "20px", textAlign: "left" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
                <h4 style={{ margin: 0, textAlign: "left" }}>Topic: {topic?.title}</h4>
                {isCompleted && (
                  <span className={`${classes.statusBadge} ${classes.statusBadgePublished}`}>
                    <Icon icon="mdi:check-circle" style={{ marginRight: 4 }} /> Completed
                  </span>
                )}
              </div>

              <div style={{ marginTop: 20 }}>
                <h4 style={{ marginBottom: 6, textAlign: "left" }}>Objectives</h4>
                <p style={{ color: "#667085", margin: 0, textAlign: "left" }}>{topic?.objective}</p>
              </div>

              <div style={{ marginTop: 24 }}>
                <p style={{ fontSize: 12, fontWeight: 600, color: "#98A2B3", letterSpacing: 0.5, textAlign: "left" }}>RESOURCES</p>

                {materials.length === 0 ? (
                  <div className={classes.emptyStateContainer}>
                    <div className={classes.emptyStateIcon}><Icon icon="mdi:folder-outline" /></div>
                    <h3 className={classes.emptyStateTitle}>No Resources available</h3>
                    <p className={classes.emptyStateSubtitle}>
                      There are no materials uploaded for this topic yet.
                    </p>
                  </div>
                ) : (
                  <div className={classes.materialsGrid}>
                    {materials.map((material) => {
                      const meta = getFileMeta(material?.file_name);

                      return (
                        <div key={material?.id} className={classes.materialCard} onClick={() => setPreviewMaterial(material)}>
                          <div className={classes.materialIcon} style={{ background: meta.bg, color: meta.color }}>
                            <Icon icon={meta.icon} />
                          </div>
                          <div style={{ minWidth: 0, textAlign: "left" }}>
                            <p className={classes.materialTitle}>{material?.title}</p>
                            <p className={classes.materialMeta}>{meta.label} . {formatFileSize(material?.file_size)}</p>
                          </div>
                          <div className={classes.materialActions}>
                            <Icon icon="mdi:download-outline" onClick={(e) => {
                              e.stopPropagation();
                              window.open(material?.file_url, "_blank");
                            }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}

          <MaterialPreviewModal
            isOpen={!!previewMaterial}
            closeModal={() => setPreviewMaterial(null)}
            material={previewMaterial}
          />
        </>
      }
    />
  );
};

export default StudentSyllabusTopicDetails;
